import { inject, injectable } from 'inversify-props';
import { IHttpClient, ILogger, ISettings } from '../common';
import { SeriesImage, PagedResult } from '../../models';




export interface ISeriesImageService {

	get(modelId: string, imageId: string): Promise<SeriesImage>;
	list(modelId: string): Promise<SeriesImage[]>;
	page(modelId: string, pageIndex: number, pageSize: number): Promise<PagedResult<SeriesImage>>;
	save(model: SeriesImage): Promise<SeriesImage>;
	delete(modelId: string, imageId: string): Promise<any>;
	revert(modelId: string): Promise<any>;
}

@injectable()
export class SeriesImageService implements ISeriesImageService {


	constructor(
		@inject('IHttpClient') private httpClient: IHttpClient,
		@inject('ILogger') private logger: ILogger,
		@inject('ISettings') private settings: ISettings) {}


	public get(modelId: string, imageId: string): Promise<SeriesImage> {
		const url = `${this.settings.baseUrl}${this.settings.seriesBaseUrl}/${modelId}/images/${imageId}`;
		return this.httpClient.get<SeriesImage>(url);
	}

	public list(modelId: string): Promise<SeriesImage[]> {
		const url = `${this.settings.baseUrl}${this.settings.seriesBaseUrl}/${modelId}/images`;
		return this.httpClient.get<SeriesImage[]>(url);
	}

	public page(modelId: string, pageIndex: number, pageSize: number): Promise<PagedResult<SeriesImage>> {
		const url = `${this.settings.baseUrl}${this.settings.seriesBaseUrl}/${modelId}/images/${pageIndex}/${pageSize}`;
		return this.httpClient.get<PagedResult<SeriesImage>>(url);
	}

	public save(model: SeriesImage): Promise<SeriesImage> {
		let url = `${this.settings.baseUrl}${this.settings.seriesBaseUrl}/${model.seriesId}/images`;
		if (model.id !== null && model.id !== undefined && model.id !== '') {
			url += `/${model.id}`;
			return this.httpClient.put(url, model);
		}
		return this.httpClient.post(url, model);
	}

	public delete(modelId: string, imageId: string): Promise<any> {
		const url = `${this.settings.baseUrl}${this.settings.seriesBaseUrl}/${modelId}/images/${imageId}`;
		return this.httpClient.delete(url);
	}

	public revert(modelId: string): Promise<any> {
		const url = `${this.settings.baseUrl}${this.settings.seriesBaseUrl}/${modelId}/images/revert`;
		return this.httpClient.post(url, null);
	}

}
